import { SellerFilter, MarketplaceFilter, ProductFilter, TargetingFilter } from "@/components/new-filters";
import { mapState } from 'vuex';
import FiltersFrame from "@/components/new-filters/FiltersFrame.vue";
import { EVENTS } from "@/utils/constants";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin.vue";
export default {
  name: "SearchFunnelFilters",
  components: {
    SellerFilter,
    MarketplaceFilter,
    FiltersFrame,
    ProductFilter,
    TargetingFilter
  },
  mixins: [InitializeFiltersMixin],
  computed: {
    ...mapState({
      sellers_filter: state => state.search_funnel.sellers_filter,
      marketplaces_filter: state => state.search_funnel.marketplaces_filter,
      products: state => state.search_funnel.products,
      targetings: state => state.search_funnel.targetings
    })
  },
  methods: {
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for sellers...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_SELLERS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_MARKETPLACES_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL);
      }
    },
    async applyProducts() {
      if (this.products.isModified) {
        this.products.apply();
        window.$bus.trigger(EVENTS.CLEAR_SEARCH_FUNNEL_MORE_FILTERS);
        await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_PRODUCTS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL);
      }
    },
    applyTargetings() {
      if (this.targetings.isModified) {
        this.targetings.apply();
        window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL);
      }
    },
    handleErrorOccured() {
      //console.log("[no account]");
      //this.announceNoAccounts();
    }
  }
};